import { BrandColors } from '../theme';

export const multiselectTokens = {
    root: {
        background: BrandColors.surface[0],
        borderColor: BrandColors.primary[200],
        hoverBorderColor: BrandColors.primary[400],
        focusBorderColor: BrandColors.primary[500],
        invalidBorderColor: BrandColors.red[500],
        color:BrandColors.surface[700],
        placeholderColor: BrandColors.surface[400],
        paddingX: '0.75rem',
        paddingY: '0.5rem',
        borderRadius: '6px',
    },
    option: {
        focusBackground: BrandColors.primary[50],
        selectedBackground: BrandColors.primary[50],
        selectedFocusBackground: BrandColors.primary[50],
        selectedColor: BrandColors.primary[700],
        selectedFocusColor: BrandColors.primary[700],

    },
    dropdown: {
        color: "#000"
    }
};
